<input
  #input
  matInput
  [matTooltip]="'GENERAL.PLEASE_SELECT_CITY_AND_COUNTY' | translate"
  [tabIndex]="tabIndex"
  [formControl]="inputCtrl"
  [matAutocomplete]="auto"
  [matTooltipDisabled]="!!this.selectedCounty"
  [readonly]="!this.selectedCounty"
  (blur)="onBlur()">
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayName"
  [autoActiveFirstOption]="true"
  (optionSelected)="onSelect($event)"
  (closed)="onClosed()">
  <ng-container *ngIf="this.neighborhoods">
    <mat-option *ngFor="let neighborhood of neighborhoods" [value]="neighborhood">{{ neighborhood.name }}</mat-option>
  </ng-container>
</mat-autocomplete>
<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>
